module.exports = __webpack_public_path__ + "img/server-dash.cb45901b.jpg";